export default __webpack_public_path__ + "static/media/anytime_budget_tracker.e98db480.png";